interface RouteLoadingFallbackProps {
  /** true면 헤더/네비 등 고정 UI 없이 화면 전체를 채운다 (온보딩/결제콜백 등 최상위 라우트용) */
  fullScreen?: boolean;
}

/**
 * React.lazy 라우트 전환 시 표시하는 최소 로딩 표현.
 * 전체화면 스피너 대신 기존 다크 테마와 어울리는 작은 스피너만 노출한다.
 */
export function RouteLoadingFallback({ fullScreen = false }: RouteLoadingFallbackProps) {
  return (
    <div
      className={
        fullScreen
          ? 'min-h-screen flex items-center justify-center bg-[var(--bg)]'
          : 'w-full flex items-center justify-center py-24'
      }
    >
      <div className="w-6 h-6 border-2 border-[var(--accent)] border-t-transparent rounded-full animate-spin" />
    </div>
  );
}
